/**
 * Reads the first `document.cookie` entry whose name matches `matches`.
 * Returns the raw value, or `undefined` when absent or empty. SSR-safe.
 *
 * Intentionally does not URL-decode — cookies we care about (`_ga`, `_ga_*`)
 * only contain URL-safe characters, and the downstream consumers re-encode
 * as part of building query strings.
 */
export function readCookie(
  matches: (name: string) => boolean,
): string | undefined {
  if (typeof document === "undefined") return undefined;

  for (const row of document.cookie.split("; ")) {
    const eqIdx = row.indexOf("=");
    if (eqIdx === -1) continue;
    if (!matches(row.slice(0, eqIdx))) continue;

    const value = row.slice(eqIdx + 1);
    return value || undefined;
  }
  return undefined;
}
